import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationTagsService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  public addTags(request: AddTagsRequest): Observable<Object> {
    return this.http.post(this.url('tags/sites'), request);
  }
}

export type AddTagsRequest = {
  sites: string[];
  tags: string[];
};
